export default "__VITE_ASSET__CaR01ybL__"